import { type ICombinedState } from '../reducers';

export const loaderSelector = (state: ICombinedState) => state.loader.isLoading;
